import React, {useEffect, useState} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import rewardLogo from "@irati/ui/images/reward_point.svg"
import {H6} from "@irati/ui/src/Typography"
import styled, {css} from "styled-components"
import topupService from "@irati/wallet/services/TopUp"
import currencyService from "@irati/currency/services/currency"

const Pill = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  ${({theme}) => css`
    gap: ${theme.spacing.one};
    padding: 0 ${theme.spacing.two} 0 ${theme.spacing.one};
    border-radius: 999px;
    border: thin solid ${theme.colors.greys.medium};
  `}
`

export function ExchangePill() {
  const [loading, setLoading] = useState(true)
  const [exchangeRate, setExchangeRate] = useState(0)
  const [currencyCode, setCurrencyCode] = useState("")

  useEffect(() => {
    ;(async () => {
      try {
        const code = await topupService.getCurrencyCode()
        const {rpExchangeRate} = await currencyService.getFPCashbackForCurrency(code)
        setExchangeRate(rpExchangeRate)
        setCurrencyCode(code)
        setLoading(false)
      } catch (_) {
        // silently fail, just won't show the component
      }
    })()
  }, [])

  if (loading) {
    return null
  }

  return (
    <Pill>
      <img height={20} width={20} src={rewardLogo} alt="" />
      <H6 noWrap color="ink">
        <FormattedMessage
          id="perks.flexiRewards.catalogue.exchange"
          values={{
            rewardPoints: Math.round(exchangeRate),
            localCurrency: formatCurrency({value: 1, currencyCode, isCents: false})
          }}
        />
      </H6>
    </Pill>
  )
}
